import { authenticatedGet, authenticatedPost, authenticatedPut } from "../../../api/authenticatedFetch";

const BASE = "/api/v1/forecast-lab";

export const getCompetition = async (scope = "insights") =>
  authenticatedGet(`${BASE}/competition?scope=${encodeURIComponent(scope)}`);

export const startCompetition = async ({ scope = "insights", candidates, holdout_days } = {}) =>
  authenticatedPost(`${BASE}/competition`, { scope, candidates, holdout_days });

export const putOverride = async ({ scope = "insights", series_name, algorithm } = {}) =>
  authenticatedPut(`${BASE}/overrides`, { scope, series_name, algorithm });

export const promoteConfig = async ({ scope = "insights" } = {}) =>
  authenticatedPost(`${BASE}/promote`, { scope });

export const getAllocationSourceSeries = async (sourceKey, horizon = 90) =>
  authenticatedGet(`${BASE}/allocation-sources/${encodeURIComponent(sourceKey)}?horizon=${horizon}`);
